import cn from 'bem-cn';

export var LINK = cn('link');